import { migrateCSVToFirestore, validateMigration } from './migrateToFirestore';

const runMigration = async () => {
  try {
    console.log('Starting migration...');
    
    // Fetch the CSV file with the correct name
    const response = await fetch('/data/ProverbsDailyDevotionalData.csv');
    const csvData = await response.text();
    
    // Run the migration
    console.log('Migrating data to Firestore...');
    await migrateCSVToFirestore(csvData);
    
    // Validate the migration
    console.log('Validating migration...');
    const count = await validateMigration();
    
    console.log(`Migration complete! ${count} devotionals migrated successfully.`);
    return { success: true, count };
  } catch (error) {
    console.error('Migration failed:', error);
    return { success: false, error: error.message };
  }
};

export default runMigration; 